{
  "about.blocks": "Reguligitaj serviloj",
  "about.contact": "Kontakto:",
  "about.default_locale": "Defaŭlta",
  "about.disclaimer": "Mastodon estas libera, malfermitkoda programo kaj varmarko de la firmao Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Kialo ne disponeblas",
  "about.domain_blocks.preamble": "Mastodon ĝenerale rajtigas vidi la enhavojn de uzantoj el aliaj serviloj en la fediverso, kaj komuniki kun ili. Jen la limigoj deciditaj de tiu ĉi servilo mem.",
  "about.domain_blocks.silenced.explanation": "Vi ne ĝenerale vidos profilojn kaj enhavojn de ĉi tiu servilo, krom se vi eksplice trovas aŭ estas permesita de via sekvato.",
  "about.domain_blocks.silenced.title": "Limigita",
  "about.domain_blocks.suspended.explanation": "Neniuj datumoj el tiu servilo estos prilaboritaj, konservitaj, aŭ interŝanĝitaj, do neeblas interagi aŭ komuniki kun uzantoj de tiu servilo.",
  "about.domain_blocks.suspended.title": "Suspendita",
  "about.language_label": "Lingvo",
  "about.not_available": "Ĉi tiu informo ne estas disponebla ĉe ĉi tiu servilo.",
  "about.powered_by": "Malcentrigita socia retejo pere de {mastodon}",
  "about.rules": "Reguloj de la servilo",
  "account.account_note_header": "Personaj notoj",
  "account.add_note": "Aldoni personan noton",
  "account.add_or_remove_from_list": "Aldoni al aŭ forigi el listoj",
  "account.badges.bot": "Aŭtomata",
  "account.badges.group": "Grupo",
  "account.block": "Bloki @{name}",
  "account.block_domain": "Bloki la domajnon {domain}",
  "account.block_short": "Bloko",
  "account.blocked": "Blokita",
  "account.cancel_follow_request": "Nuligi peton por sekvado",
  "account.copy": "Kopii ligilon al profilo",
  "account.direct": "Private mencii @{name}",
  "account.disable_notifications": "Ĉesu sciigi min kiam @{name} afiŝas",
  "account.edit_profile": "Redakti la profilon",
  "account.edit_profile_short": "Redakti",
  "account.enable_notifications": "Sciigu min kiam @{name} afiŝos",
  "account.endorse": "Montri en profilo",
  "account.familiar_followers_one": "Sekvita de {name1}",
  "account.familiar_followers_two": "Sekvita de {name1} kaj {name2}",
  "account.featured": "Elstarigitaj",
  "account.featured.accounts": "Profiloj",
  "account.follow": "Sekvi",
  "account.follow_back": "Sekvu reen",
  "account.follow_back_short": "Sekvu reen",
  "account.follow_request_cancel_short": "Nuligi",
  "account.followers": "Sekvantoj",
  "account.followers.empty": "Ankoraŭ neniu sekvas ĉi tiun uzanton.",
  "account.followers_counter": "{count, plural, one{{counter} sekvanto} other {{counter} sekvantoj}}",
  "account.followers_you_know_counter": "Vi scias {counter}",
  "account.following": "Sekvatoj",
  "account.following_counter": "{count, plural, one {{counter} sekvato} other {{counter} sekvatoj}}",
  "account.follows.empty": "La uzanto ankoraŭ ne sekvas iun ajn.",
  "account.follows_you": "Sekvas vin",
  "account.go_to_profile": "Iri al profilo",
  "account.hide_reblogs": "Kaŝi diskonigojn de @{name}",
  "account.in_memoriam": "Memore.",
  "account.joined_short": "Aliĝis",
  "account.languages": "Ŝanĝi la abonitajn lingvojn",
  "account.link_verified_on": "La posedanto de tiu ligilo estis kontrolita je {date}",
  "account.locked_info": "La privateco de tiu konto estas elektita kiel fermita. La posedanto povas mane akcepti tiun, kiu povas sekvi rin.",
  "account.media": "Aŭdovidaĵoj",
  "account.mention": "Mencii @{name}",
  "account.menu.add_to_list": "Aldoni al listo…",
  "account.menu.block": "Bloki konton",
  "account.menu.block_domain": "Bloki {domain}",
  "account.moved_to": "{name} indikis, ke ria nova konto estas nun:",
  "account.mute": "Silentigi @{name}",
  "account.mute_notifications_short": "Silentigu sciigojn",
  "account.mute_short": "Silentigu",
  "account.muted": "Silentigita",
  "account.mutual": "Vi sekvas unu la alian",
  "account.no_bio": "Neniu priskribo estas provizita.",
  "account.node_modal.field_label": "Persona noto",
  "account.open_original_page": "Malfermi la originalan paĝon",
  "account.posts": "Afiŝoj",
  "account.remove_from_followers": "Forigi {name}-n de sekvantoj",
  "account.report": "Raporti @{name}",
  "account.requested_follow": "{name} petis sekvi vin",
  "account.share": "Diskonigi la profilon de @{name}",
  "account.show_reblogs": "Montri diskonigojn de @{name}",
  "account.statuses_counter": "{count, plural,one {{counter} afiŝo} other {{counter} afiŝoj}}",
  "account.unblock": "Malbloki @{name}",
  "account.unblock_domain": "Malbloki la domajnon {domain}",
  "account.unblock_domain_short": "Malbloki",
  "account.unblock_short": "Malbloki",
  "account.unendorse": "Ne plu rekomendi ĉe la profilo",
  "account.unfollow": "Ne plu sekvi",
  "account.unmute": "Malsilentigi @{name}",
  "account.unmute_notifications_short": "Malsilentigu sciigojn",
  "account.unmute_short": "Ne plu silentigi",
  "account_edit.featured_hashtags.title": "Elstarigitaj kradvortoj",
  "account_edit.save": "Konservi",
  "account_edit_tags.add_tag": "Aldoni #{tagName}",
  "account_note.placeholder": "Alklaku por aldoni noton",
  "admin.dashboard.daily_retention": "Uzantoretenprocento laŭ tag post registro",
  "admin.dashboard.monthly_retention": "Uzantoretenprocento laŭ monato post registro",
  "admin.dashboard.retention.average": "Averaĝa",
  "admin.dashboard.retention.cohort": "Monato de registriĝo",
  "admin.dashboard.retention.cohort_size": "Novaj uzantoj",
  "admin.impact_report.instance_accounts": "Kontojn kaj profilojn tio forigus",
  "admin.impact_report.instance_followers": "Sekvantojn niaj uzantoj perdus",
  "admin.impact_report.instance_follows": "Sekvantojn ties uzantoj perdus",
  "admin.impact_report.title": "Influa reporto",
  "alert.rate_limited.message": "Bonvolu reprovi poste {retry_time, time, medium}.",
  "alert.rate_limited.title": "Mesaĝkvante limigita",
  "alert.unexpected.message": "Neatendita eraro okazis.",
  "alert.unexpected.title": "Ups!",
  "alt_text_badge.title": "Alt-teksto",
  "alt_text_modal.add_alt_text": "Aldoni alttekston",
  "alt_text_modal.add_text_from_image": "Aldoni tekston de bildo",
  "alt_text_modal.cancel": "Nuligi",
  "alt_text_modal.change_thumbnail": "Ŝanĝi bildeton",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Priskribi ĉi tion por homoj kun aŭdmalkapabloj…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Priskribi ĉi tion por homoj kun vidaj malkapabloj…",
  "alt_text_modal.done": "Farita",
  "announcement.announcement": "Anonco",
  "annual_report.announcement.action_dismiss": "Ne, dankon",
  "annual_report.nav_item.badge": "Nova",
  "annual_report.shared_page.donate": "Donaci",
  "annual_report.summary.close": "Fermi",
  "annual_report.summary.copy_link": "Kopii ligilon",
  "annual_report.summary.highlighted_post.title": "Plej populara afiŝo",
  "annual_report.summary.most_used_app.most_used_app": "plej uzita aplikaĵo",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "plej uzata kradvorto",
  "annual_report.summary.new_posts.new_posts": "novaj afiŝoj",
  "annual_report.summary.percentile.text": "<topLabel>Tion metas vin en la plej</topLabel><percentage></percentage><bottomLabel>de {domain} uzantoj.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Ni ne diros al Zamenhof.",
  "attachments_list.unprocessed": "(neprilaborita)",
  "audio.hide": "Kaŝi aŭdion",
  "block_modal.remote_users_caveat": "Ni petos al la servilo {domain} respekti vian elekton. Tamen, plenumo ne estas garantiita ĉar iuj serviloj eble manipulas blokojn malsame. Publikaj afiŝoj eble ankoraŭ estas videbla por ne-ensalutintaj uzantoj.",
  "block_modal.show_less": "Montri malpli",
  "block_modal.show_more": "Montri pli",
  "block_modal.they_will_know": "Ili povas vidi, ke ili estas blokita.",
  "block_modal.title": "Ĉu bloki uzanton?",
  "boost_modal.combo": "Vi povas premi {combo} por preterpasi sekvafoje",
  "boost_modal.reblog": "Ĉu diskonigi afiŝon?",
  "boost_modal.undo_reblog": "Ĉu ĉesi diskonigi afiŝon?",
  "bundle_column_error.copy_stacktrace": "Kopii la eraran raporton",
  "bundle_column_error.error.body": "La petita paĝo ne povas redonitis. Eble estas eraro.",
  "bundle_column_error.error.title": "Ho, ve!",
  "bundle_column_error.network.body": "Okazis eraro dum ŝarĝado de ĉi tiu paĝo. Tion povas kaŭzi portempa problemo pri via retkonektado aŭ pri ĉi tiu servilo.",
  "bundle_column_error.network.title": "Eraro de reto",
  "bundle_column_error.retry": "Provu denove",
  "bundle_column_error.return": "Reiri hejmen",
  "bundle_column_error.routing.body": "La celita paĝo ne troveblas. Ĉu vi certas, ke la retadreso (URL) en via retfoliumilo estas ĝusta?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Fermi",
  "bundle_modal_error.message": "Io misfunkciis dum ŝarĝo de ĉi tiu ekrano.",
  "bundle_modal_error.retry": "Provu denove",
  "closed_registrations.other_server_instructions": "Ĉar Mastodon estas malcentraliza, vi povas krei konton ĉe alia servilo kaj ankoraŭ komuniki kun ĉi tiu.",
  "closed_registrations_modal.description": "Krei konton ĉe {domain} aktuale ne eblas, tamen bonvole rimarku, ke vi ne bezonas konton specife ĉe {domain} por uzi Mastodon.",
  "closed_registrations_modal.find_another_server": "Trovi alian servilon",
  "closed_registrations_modal.preamble": "Mastodon estas malcentraliza, do sendepende de tio, kie vi kreas vian konton, vi povos sekvi kaj komuniki kun ĉiuj ajn el ĉi tiu servilo. Vi eĉ povas mem starigi propran servilon!",
  "closed_registrations_modal.title": "Registriĝi en Mastodon",
  "collections.create_collection": "Krei kolekton",
  "collections.delete_collection": "Forigi kolekton",
  "column.about": "Pri",
  "column.blocks": "Blokitaj uzantoj",
  "column.bookmarks": "Legosignoj",
  "column.community": "Loka templinio",
  "column.create_list": "Krei liston",
  "column.direct": "Privataj mencioj",
  "column.directory": "Foliumi la profilojn",
  "column.domain_blocks": "Blokitaj domajnoj",
  "column.edit_list": "Redakti liston",
  "column.favourites": "Stelumoj",
  "column.firehose": "Rektaj fluoj",
  "column.follow_requests": "Petoj de sekvado",
  "column.home": "Hejmo",
  "column.list_members": "Administri listanojn",
  "column.lists": "Listoj",
  "column.mutes": "Silentigitaj uzantoj",
  "column.notifications": "Sciigoj",
  "column.pins": "Alpinglitaj afiŝoj",
  "column.public": "Fratara tempolinio",
  "column_back_button.label": "Reveni",
  "column_header.hide_settings": "Kaŝi agordojn",
  "column_header.moveLeft_settings": "Movi kolumnon maldekstren",
  "column_header.moveRight_settings": "Movi kolumnon dekstren",
  "column_header.pin": "Fiksi",
  "column_header.show_settings": "Montri agordojn",
  "column_header.unpin": "Malfiksi",
  "column_search.cancel": "Nuligi",
  "community.column_settings.local_only": "Nur loka",
  "community.column_settings.media_only": "Nur aŭdovidaĵoj",
  "community.column_settings.remote_only": "Nur fora",
  "compose.error.blank_post": "Afiŝo ne povas esti malplena.",
  "compose.language.change": "Ŝanĝi lingvon",
  "compose.language.search": "Serĉi lingvojn...",
  "compose.published.body": "Afiŝo publikigita.",
  "compose.published.open": "Malfermi",
  "compose.saved.body": "Afiŝo konservita.",
  "compose_form.direct_message_warning_learn_more": "Lerni pli",
  "compose_form.encryption_warning": "La afiŝoj en Mastodon ne estas tutvoje ĉifritaj. Ne kunhavigu tiklajn informojn ĉe Mastodon.",
  "compose_form.hashtag_warning": "Ĉi tiu afiŝo ne estos listigita en neniu kradvorto ĉar ĝi ne estas publika. Nur publikaj afiŝoj povas esti serĉitaj per kradvortoj.",
  "compose_form.lock_disclaimer": "Via konta ne estas {locked}. Iu ajn povas sekvi vin por vidi viajn mesaĝojn, kiuj estas nur por sekvantoj.",
  "compose_form.lock_disclaimer.lock": "ŝlosita",
  "compose_form.placeholder": "Pri kio vi pensas?",
  "compose_form.poll.duration": "Daŭro de la balotenketo",
  "compose_form.poll.multiple": "Multebla elekto",
  "compose_form.poll.option_placeholder": "Opcio {number}",
  "compose_form.poll.single": "Ununura elekto",
  "compose_form.poll.switch_to_multiple": "Ŝanĝi la balotenketon por permesi multajn elektojn",
  "compose_form.poll.switch_to_single": "Ŝanĝi la balotenketon por permesi unu solan elekton",
  "compose_form.poll.type": "Stilo",
  "compose_form.publish": "Afiŝi",
  "compose_form.reply": "Respondi",
  "compose_form.save_changes": "Ĝisdatigi",
  "compose_form.spoiler.marked": "Forigi la averton de enhavo",
  "compose_form.spoiler.unmarked": "Aldoni averton de enhavo",
  "compose_form.spoiler_placeholder": "Enhava Averto (nedeviga)",
  "confirmation_modal.cancel": "Nuligi",
  "confirmations.block.confirm": "Bloki",
  "confirmations.delete.confirm": "Forigi",
  "confirmations.delete.message": "Ĉu vi certas, ke vi volas forigi ĉi tiun afiŝon?",
  "confirmations.delete.title": "Ĉu forigi afiŝon?",
  "confirmations.delete_list.confirm": "Forigi",
  "confirmations.delete_list.message": "Ĉu vi certas, ke vi volas porĉiame forigi ĉi tiun liston?",
  "confirmations.delete_list.title": "Ĉu forigi liston?",
  "confirmations.discard_draft.confirm": "Forĵetu kaj daŭrigu",
  "confirmations.discard_draft.edit.cancel": "Daŭrigi redaktadon",
  "confirmations.discard_draft.edit.message": "Daŭrigo forigos ĉiujn ŝanĝojn, kiujn vi faris al la afiŝo, kiun vi nun redaktas.",
  "confirmations.discard_draft.edit.title": "Ĉu forĵeti ŝanĝojn al via afiŝo?",
  "confirmations.discard_draft.post.cancel": "Daŭrigi malneton",
  "confirmations.discard_draft.post.message": "Daŭrigo forigos la afiŝon, kiun vi nun verkas.",
  "confirmations.discard_draft.post.title": "Ĉu forĵeti vian malneton?",
  "confirmations.discard_edit_media.confirm": "Forĵeti",
  "confirmations.discard_edit_media.message": "Vi havas nekonservitajn ŝanĝojn de la priskribo aŭ la antaŭvidigo de la vidaŭdaĵo, ĉu vi forĵetu ilin malgraŭe?",
  "confirmations.follow_to_list.confirm": "Sekvi kaj aldoni al listo",
  "confirmations.follow_to_list.message": "Vi devas sekvi {name} por aldoni ilin al listo.",
  "confirmations.follow_to_list.title": "Ĉu sekvi uzanton?",
  "confirmations.logout.confirm": "Elsaluti",
  "confirmations.logout.message": "Ĉu vi certas, ke vi volas elsaluti?",
  "confirmations.logout.title": "Ĉu elsaluti?",
  "confirmations.missing_alt_text.confirm": "Aldoni alttekston",
  "confirmations.missing_alt_text.message": "Via afiŝo enhavas aŭdvidaĵon sen alternativa teksto. Aldono de priskriboj helpas fari vian enhavon alirebla por pli da homoj.",
  "confirmations.missing_alt_text.secondary": "Afiŝi ĉiuokaze",
  "confirmations.missing_alt_text.title": "Ĉu aldoni alttekston?",
  "confirmations.mute.confirm": "Silentigi",
  "confirmations.private_quote_notify.confirm": "Publikigi afiŝon",
  "confirmations.private_quote_notify.do_not_show_again": "Ne montru al mi ĉi tiun mesaĝon denove",
  "confirmations.quiet_post_quote_info.dismiss": "Ne memorigu min denove",
  "confirmations.quiet_post_quote_info.got_it": "Komprenite",
  "confirmations.redraft.confirm": "Forigi kaj reskribi",
  "confirmations.redraft.message": "Ĉu vi certas ke vi volas forigi tiun afiŝon kaj reskribi ĝin? Ĉiuj diskonigoj kaj stelumoj estos perditaj, kaj respondoj al la originala mesaĝo estos senparentaj.",
  "confirmations.redraft.title": "Ĉu forigi kaj redakcii afiŝon?",
  "confirmations.remove_from_followers.confirm": "Forigi sekvanton",
  "confirmations.remove_from_followers.message": "{name} ne plu sekvos vin. Ĉu vi certas ke vi volas daŭri?",
  "confirmations.remove_from_followers.title": "Forigi sekvanton?",
  "confirmations.revoke_quote.confirm": "Forigi afiŝon",
  "confirmations.revoke_quote.message": "Ĉi tiu ago ne povas esti malfarita.",
  "confirmations.revoke_quote.title": "Ĉu forigi afiŝon?",
  "confirmations.unfollow.confirm": "Ne plu sekvi",
  "content_warning.hide": "Kaŝi afiŝon",
  "content_warning.show": "Montri ĉiukaze",
  "content_warning.show_more": "Montri pli",
  "conversation.delete": "Forigi konversacion",
  "conversation.mark_as_read": "Marku kiel legita",
  "conversation.open": "Vidi konversacion",
  "conversation.with": "Kun {names}",
  "copy_icon_button.copied": "Kopiis al kliptabulo",
  "copypaste.copied": "Kopiita",
  "copypaste.copy_to_clipboard": "Kopii al dosierujo",
  "directory.federated": "El konata fediverso",
  "directory.local": "Nur de {domain}",
  "directory.new_arrivals": "Novaj alvenoj",
  "directory.recently_active": "Lastatempe aktiva",
  "disabled_account_banner.account_settings": "Konto-agordoj",
  "disabled_account_banner.text": "Via konto {disabledAccount} estas nune malvalidigita.",
  "dismissable_banner.community_timeline": "Jen la plej novaj publikaj afiŝoj de uzantoj, kies kontojn gastigas {domain}.",
  "dismissable_banner.dismiss": "Eksigi",
  "dismissable_banner.public_timeline": "Ĉi tiuj estas la plej ĵusaj publikaj afiŝoj de homoj en la fediverso, kiujn la homoj en {domain} sekvas.",
  "domain_block_modal.block": "Bloki servilon",
  "domain_block_modal.block_account_instead": "Bloki @{name} anstataŭe",
  "domain_block_modal.they_can_interact_with_old_posts": "Homoj de ĉi tiu servilo povas interagi kun viaj malnovaj afiŝoj.",
  "domain_block_modal.they_cant_follow": "Neniu el ĉi tiu servilo povas sekvi vin.",
  "domain_block_modal.they_wont_know": "Ili ne scios, ke ili estas blokitaj.",
  "domain_block_modal.title": "Ĉu bloki domajnon?",
  "domain_block_modal.you_will_lose_num_followers": "Vi perdos {followersCount, plural, one {{followersCountDisplay} sekvanton} other {{followersCountDisplay} sekvantojn}} kaj {followingCount, plural, one {{followingCountDisplay} homon, kiu vi sekvas} other {{followingCountDisplay} homojn, kiuj vi sekvas}}.",
  "domain_block_modal.you_will_lose_relationships": "Vi perdos ĉiujn sekvantojn kaj homojn, kiujn vi sekvas de ĉi tiu servilo.",
  "domain_block_modal.you_wont_see_posts": "Vi ne vidos afiŝojn aŭ sciigojn de uzantoj sur ĉi tiu servilo.",
  "domain_pill.activitypub_lets_connect": "Ĝi ebligas vin konekti kaj interagi kun homoj ne nur sur Mastodon, sed ankaŭ tra diversaj sociaj aplikaĵoj.",
  "domain_pill.activitypub_like_language": "ActivityPub estas kiel la lingvo kiun Mastodon parolas kun aliaj sociaj retoj.",
  "domain_pill.server": "Servilo",
  "domain_pill.their_handle": "Ilia identigo:",
  "domain_pill.their_server": "Ilia cifereca hejmo, kie ĉiuj iliaj afiŝoj loĝas.",
  "domain_pill.their_username": "Ilia unika identigilo sur ilia servilo. Eblas trovi uzantojn kun la sama uzantnomo sur malsamaj serviloj.",
  "domain_pill.username": "Uzantnomo",
  "domain_pill.whats_in_a_handle": "Kio estas en identigo?",
  "domain_pill.who_they_are": "Ĉar identigoj diras, kiu iu estas kaj kie ili estas, vi povas interagi kun homoj tra la socia reto de <button>ActivityPub-funkciigitaj platformoj</button>.",
  "domain_pill.who_you_are": "Ĉar via identigo diras kiu vi estas kaj kie vi estas, homoj povas interagi kun vi tra la socia reto de <button>ActivityPub-funkciigitaj platformoj</button>.",
  "domain_pill.your_handle": "Via identigo:",
  "domain_pill.your_server": "Via cifereca hejmo, kie loĝas ĉiuj viaj afiŝoj. Ĉu vi ne ŝatas ĉi tiun? Transloku servilojn iam ajn kaj alportu ankaŭ viajn sekvantojn.",
  "domain_pill.your_username": "Via unika identigilo sur ĉi tiu servilo. Eblas trovi uzantojn kun la sama uzantnomo sur malsamaj serviloj.",
  "dropdown.empty": "Elektu opcion",
  "embed.instructions": "Enkorpigu ĉi tiun afiŝon en vian retejon per kopio de la suba kodo.",
  "embed.preview": "Ĝi aperos tiel:",
  "emoji_button.activity": "Agadoj",
  "emoji_button.clear": "Forviŝi",
  "emoji_button.custom": "Propraj",
  "emoji_button.flags": "Flagoj",
  "emoji_button.food": "Manĝi kaj trinki",
  "emoji_button.label": "Enmeti emoĝion",
  "emoji_button.nature": "Naturo",
  "emoji_button.not_found": "Neniuj kongruaj emoĝioj trovitaj",
  "emoji_button.objects": "Aĵoj",
  "emoji_button.people": "Homoj",
  "emoji_button.recent": "Ofte uzataj",
  "emoji_button.search": "Serĉo...",
  "emoji_button.search_results": "Serĉaj rezultoj",
  "emoji_button.symbols": "Simboloj",
  "emoji_button.travel": "Vojaĝoj kaj lokoj",
  "empty_column.account_hides_collections": "Ĉi tiu uzanto elektis ne disponebligi ĉi tiu informon",
  "empty_column.account_suspended": "Konto suspendita",
  "empty_column.account_timeline": "Neniuj afiŝoj ĉi tie!",
  "empty_column.account_unavailable": "Profilo nedisponebla",
  "empty_column.blocks": "Vi ankoraŭ ne blokis uzanton.",
  "empty_column.bookmarked_statuses": "Vi ankoraŭ ne aldonis afiŝon al viaj legosignoj. Kiam vi aldonos iun, tiu aperos ĉi tie.",
  "empty_column.community": "La loka templinio estas malplena. Skribu ion por plenigi ĝin!",
  "empty_column.direct": "Vi ankoraŭ ne havas privatan mencion. Kiam vi sendos aŭ ricevos iun, tiu aperos ĉi tie.",
  "empty_column.domain_blocks": "Ankoraŭ neniu domajno estas blokita.",
  "empty_column.explore_statuses": "Nenio tendencas nun. Rekontrolu poste!",
  "empty_column.favourited_statuses": "Vi ankoraŭ ne havas plej ŝatatajn afiŝojn. Kiam vi ŝatatas unu, ĝi aperos ĉi tie.",
  "empty_column.favourites": "Neniu ankoraŭ ŝatis ĉi tiun afiŝon. Kiam iu ŝatos ĝin, ili aperos ĉi tie.",
  "empty_column.follow_requests": "Vi ne ankoraŭ havas iun peton de sekvado. Kiam vi ricevos unu, ĝi aperos ĉi tie.",
  "empty_column.followed_tags": "Vi ankoraŭ ne sekvas iujn kradvortojn. Kiam vi faras, ili aperos ĉi tie.",
  "empty_column.hashtag": "Ankoraŭ estas nenio per ĉi tiu kradvorto.",
  "empty_column.home": "Via hejma tempolinio estas malplena! Vizitu {public} aŭ uzu la serĉilon por renkonti aliajn uzantojn.",
  "empty_column.list": "Ankoraŭ estas nenio en ĉi tiu listo. Kiam membroj de ĉi tiu listo afiŝos novajn afiŝojn, ili aperos ĉi tie.",
  "empty_column.mutes": "Vi ne ankoraŭ silentigis iun uzanton.",
  "empty_column.notification_requests": "Ĉio klara! Estas nenio tie ĉi. Kiam vi ricevas novajn sciigojn, ili aperos ĉi tie laŭ viaj agordoj.",
  "empty_column.notifications": "Vi ankoraŭ ne havas sciigojn. Interagu kun aliaj por komenci konversacion.",
  "empty_column.public": "Estas nenio ĉi tie! Publike skribu ion, aŭ mane sekvu uzantojn de aliaj serviloj por plenigi la publikan tempolinion",
  "error.unexpected_crash.explanation": "Pro eraro en nia kodo, aŭ problemo de kongruo en via retumilo, ĉi tiu paĝo ne povis esti montrata ĝuste.",
  "error.unexpected_crash.explanation_addons": "Ĉi tiu paĝo ne povis esti montrita ĝuste. Ĉi tiu eraro probable estas kaŭzita de retumila aldonaĵo aŭ aŭtomataj tradukiloj.",
  "error.unexpected_crash.next_steps": "Provu refreŝigi la paĝon. Se tio ne helpas, vi ankoraŭ povus uzi Mastodon per malsama retumilo aŭ operaciuma aplikajo.",
  "error.unexpected_crash.next_steps_addons": "Provu malaktivigi ilin kaj tiam refreŝigi la paĝon. Se tio ne helpas, vi ankoraŭ povus uzi Mastodon per malsama retumilo aŭ operaciuma aplikajo.",
  "errors.unexpected_crash.copy_stacktrace": "Kopii stakspuron en tondujo",
  "errors.unexpected_crash.report_issue": "Raporti problemon",
  "explore.suggested_follows": "Homoj",
  "explore.title": "Popularaĵoj",
  "explore.trending_links": "Novaĵoj",
  "explore.trending_statuses": "Afiŝoj",
  "explore.trending_tags": "Kradvortoj",
  "featured_carousel.header": "{count, plural, one {Alpinglita afiŝo} other {Alpinglitaj afiŝoj}}",
  "featured_carousel.slide": "Afiŝo {current, number} de {max, number}",
  "featured_tags.more_items": "+{count}",
  "filter_modal.added.context_mismatch_explanation": "Ĉi tiu filtrilkategorio ne kongruas kun la kunteksto en kiu vi akcesis ĉi tiun afiŝon. Se vi volas ke la afiŝo estas ankaŭ filtrita en ĉi tiu kunteksto, vi devus redakti la filtrilon.",
  "filter_modal.added.context_mismatch_title": "Ne kongruas la kunteksto!",
  "filter_modal.added.expired_explanation": "Ĉi tiu filtrilkategorio eksvalidiĝis, vu bezonos ŝanĝi la eksvaliddaton por ĝi.",
  "filter_modal.added.expired_title": "Eksvalida filtrilo!",
  "filter_modal.added.review_and_configure": "Por kontroli kaj pli modifi ĉi tiu filtrilkategorio, iru al la {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Filtrilopcioj",
  "filter_modal.added.settings_link": "opciopaĝo",
  "filter_modal.added.short_explanation": "Ĉi tiu afiŝo aldonitas al la filtrilkategorio: {title}.",
  "filter_modal.added.title": "Filtrilo aldonita!",
  "filter_modal.select_filter.context_mismatch": "ne kongruas la kuntekston",
  "filter_modal.select_filter.expired": "eksvalidiĝinta",
  "filter_modal.select_filter.prompt_new": "Nova klaso: {name}",
  "filter_modal.select_filter.search": "Serĉi aŭ krei",
  "filter_modal.select_filter.subtitle": "Uzu ekzistantan kategorion aŭ kreu novan",
  "filter_modal.select_filter.title": "Filtri ĉi tiun afiŝon",
  "filter_modal.title.status": "Filtri afiŝon",
  "filter_warning.matches_filter": "Filtrilo de kongruoj “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "El {count, plural, =0 {neniu} one {unu persono} other {# homoj}} vi eble konas",
  "filtered_notifications_banner.title": "Filtritaj sciigoj",
  "firehose.all": "Ĉiuj",
  "firehose.local": "Ĉi tiu servilo",
  "firehose.remote": "Aliaj serviloj",
  "follow_request.authorize": "Rajtigi",
  "follow_request.reject": "Rifuzi",
  "follow_requests.unlocked_explanation": "Kvankam via konto ne estas ŝlosita, la dungitaro de {domain} opinias, ke vi eble volas revizii petojn pri sekvado de ĉi tiuj kontoj permane.",
  "follow_suggestions.curated_suggestion": "Elekto de stabo",
  "follow_suggestions.dismiss": "Ne montri denove",
  "follow_suggestions.featured_longer": "Mane elektita de la teamo de {domain}",
  "follow_suggestions.friends_of_friends_longer": "Populara inter homoj, kiujn vi sekvas",
  "follow_suggestions.hints.featured": "Ĉi tiu profilo estis mane elektita de la teamo de {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Ĉi tiu profilo estas populara inter la homoj, kiujn vi sekvas.",
  "follow_suggestions.hints.most_followed": "Ĉi tiu profilo estas unu el la plej sekvataj en {domain}.",
  "follow_suggestions.hints.most_interactions": "Ĉi tiu profilo lastatempe ricevis multe da atento sur {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Ĉi tiu profilo similas al la profiloj kiujn vi plej lastatempe sekvis.",
  "follow_suggestions.personalized_suggestion": "Agordita propono",
  "follow_suggestions.popular_suggestion": "Popularaj proponoj",
  "follow_suggestions.popular_suggestion_longer": "Populara en {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Simile al profiloj, kiujn vi lastatempe sekvis",
  "follow_suggestions.view_all": "Vidi ĉiujn",
  "follow_suggestions.who_to_follow": "Kiun sekvi",
  "followed_tags": "Sekvataj kradvortoj",
  "footer.about": "Pri",
  "footer.about_mastodon": "Pri Mastodon",
  "footer.about_server": "Pri {domain}",
  "footer.about_this_server": "Pri",
  "footer.directory": "Profilujo",
  "footer.get_app": "Akiri la apon",
  "footer.keyboard_shortcuts": "Fulmoklavoj",
  "footer.privacy_policy": "Politiko de privateco",
  "footer.source_code": "Montri fontkodon",
  "footer.status": "Stato",
  "footer.terms_of_service": "Kondiĉoj de uzado",
  "generic.saved": "Konservita",
  "getting_started.heading": "Por komenci",
  "hashtag.admin_moderation": "Malfermi fasadon de moderigado por #{name}",
  "hashtag.browse": "Folii afiŝojn en #{hashtag}",
  "hashtag.browse_from_account": "Folii afiŝojn de @{name} en #{hashtag}",
  "hashtag.column_header.tag_mode.all": "kaj {additional}",
  "hashtag.column_header.tag_mode.any": "aŭ {additional}",
  "hashtag.column_header.tag_mode.none": "sen {additional}",
  "hashtag.column_settings.select.no_options_message": "Neniuj sugestoj trovitaj",
  "hashtag.column_settings.select.placeholder": "Enmeti kradvortojn…",
  "hashtag.column_settings.tag_mode.all": "Ĉiuj",
  "hashtag.column_settings.tag_mode.any": "Iu ajn",
  "hashtag.column_settings.tag_mode.none": "Neniu",
  "hashtag.column_settings.tag_toggle": "Aldoni pliajn etikedojn por ĉi tiu kolumno",
  "hashtag.counter_by_accounts": "{count, plural,one {{counter} partoprenanto} other {{counter} partoprenantoj}}",
  "hashtag.counter_by_uses": "{count, plural,one {{counter} afiŝo} other {{counter} afiŝoj}}",
  "hashtag.counter_by_uses_today": "{count, plural,one {{counter} afiŝo} other {{counter} afiŝoj}} hodiaŭ",
  "hashtag.feature": "Prezenti en profilo",
  "hashtag.follow": "Sekvi la kradvorton",
  "hashtag.mute": "Silentigi #{hashtag}",
  "hashtag.unfeature": "Ne prezenti en profilo",
  "hashtag.unfollow": "Ne plu sekvi la kradvorton",
  "hashtags.and_other": "…kaj {count, plural,other {# pli}}",
  "hints.profiles.followers_may_be_missing": "Sekvantoj por ĉi tiu profilo eble mankas.",
  "hints.profiles.follows_may_be_missing": "Sekvatoj de ĉi tiu profilo eble mankas.",
  "hints.profiles.posts_may_be_missing": "Iuj afiŝoj de ĉi tiu profilo eble mankas.",
  "hints.profiles.see_more_followers": "Vidi pli da sekvantoj sur {domain}",
  "hints.profiles.see_more_follows": "Vidi pli da sekvatoj sur {domain}",
  "hints.profiles.see_more_posts": "Vidi pli da afiŝoj sur {domain}",
  "home.column_settings.show_quotes": "Montri citaĵojn",
  "home.column_settings.show_reblogs": "Montri diskonigojn",
  "home.column_settings.show_replies": "Montri respondojn",
  "home.hide_announcements": "Kaŝi la anoncojn",
  "home.pending_critical_update.body": "Ĝisdatigu vian servilon de Mastodon kiel eble plej baldau!",
  "home.pending_critical_update.link": "Vidi ĝisdatigojn",
  "home.pending_critical_update.title": "Kritika sekurĝisdatigo estas disponebla!",
  "home.show_announcements": "Montri anoncojn",
  "ignore_notifications_modal.disclaimer": "Mastodon ne povas informi uzantojn, ke vi ignoris iliajn sciigojn. Ignori sciigojn ne malhelpos la mesaĝojn mem esti senditaj.",
  "ignore_notifications_modal.filter_instead": "Filtri anstataŭe",
  "ignore_notifications_modal.filter_to_act_users": "Vi ankoraŭ povos akcepti, malakcepti aŭ raporti uzantojn",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtrado helpas eviti eblan konfuzon",
  "ignore_notifications_modal.filter_to_review_separately": "Vi povas revizii filtritajn sciigojn aparte",
  "ignore_notifications_modal.ignore": "Ignori sciigojn",
  "ignore_notifications_modal.limited_accounts_title": "Ĉu ignori sciigojn de moderigitaj kontoj?",
  "ignore_notifications_modal.new_accounts_title": "Ĉu ignori sciigojn de novaj kontoj?",
  "ignore_notifications_modal.not_followers_title": "Ĉu ignori sciigojn de homoj, kiuj ne sekvas vin?",
  "ignore_notifications_modal.not_following_title": "Ĉu ignori sciigojn de homoj, kiujn vi ne sekvas?",
  "ignore_notifications_modal.private_mentions_title": "Ĉu ignori sciigojn de nepetitaj privataj mencioj?",
  "info_button.label": "Helpo",
  "info_button.what_is_alt_text": "<h1>Kio estas la alternativa teksto?</h1> <p>La alternativa teksto ofertas priskribojn de la bildoj por individuoj kun vidaj malfacilaĵoj, konektoj kun malalta larĝa bando aŭ kiuj serĉas plian kuntekston.</p> <p>Vi povas plibonigi alireblecon kaj komprenon por ĉiuj per skribado de klaraj, koncizaj, kaj objektivaj alternativaj tekstoj.</p><ul><li>Kaptu gravajn elementojn.</li><li> Resumu tekston en bildoj.</li> <li>Uzu regulan frazstrukturon.</li> <li>Evitu redundan informon.</li><li>Fokusu sur tendencoj kaj ĉefaj trovoj en kompleksaj visualoj (kiel diagramoj aŭ mapoj).</li></ul>",
  "interaction_modal.go": "Iru",
  "interaction_modal.no_account_yet": "Ĉu vi ankoraŭ ne havas konton?",
  "interaction_modal.on_another_server": "En alia servilo",
  "interaction_modal.on_this_server": "En ĉi tiu servilo",
  "interaction_modal.username_prompt": "Ekz. {example}",
  "intervals.full.days": "{number, plural, one {# tago} other {# tagoj}}",
  "intervals.full.hours": "{number, plural, one {# horo} other {# horoj}}",
  "intervals.full.minutes": "{number, plural, one {# minuto} other {# minutoj}}",
  "keyboard_shortcuts.back": "Reiru reen",
  "keyboard_shortcuts.blocked": "Malfermi la liston de blokitaj uzantoj",
  "keyboard_shortcuts.boost": "Diskonigi la mesaĝon",
  "keyboard_shortcuts.column": "Fokusi kolumnon",
  "keyboard_shortcuts.compose": "Enfokusigi la tekstaron",
  "keyboard_shortcuts.description": "Priskribo",
  "keyboard_shortcuts.down": "Movu malsupren en la listo",
  "keyboard_shortcuts.enter": "Malfermi afiŝon",
  "keyboard_shortcuts.favourite": "Stelumi afiŝon",
  "keyboard_shortcuts.favourites": "Malfermi la liston de la stelumoj",
  "keyboard_shortcuts.federated": "Malfermi la frataran templinion",
  "keyboard_shortcuts.heading": "Fulmoklavoj",
  "keyboard_shortcuts.home": "Malfermi la hejman templinion",
  "keyboard_shortcuts.hotkey": "Rapidklavo",
  "keyboard_shortcuts.legend": "Montru ĉi tiun legendon",
  "keyboard_shortcuts.local": "Malfermu la lokan templinion",
  "keyboard_shortcuts.mention": "Menciu aŭtoron",
  "keyboard_shortcuts.muted": "Malfermu la liston de silentigitaj uzantoj",
  "keyboard_shortcuts.my_profile": "Malfermu vian profilon",
  "keyboard_shortcuts.notifications": "Malfermu la sciigajn kolumnon",
  "keyboard_shortcuts.open_media": "Malfermi vidaŭdaĵon",
  "keyboard_shortcuts.pinned": "Malfermu alpinglitajn afiŝojn-liston",
  "keyboard_shortcuts.profile": "Malfermu la profilon de aŭtoroprofilo",
  "keyboard_shortcuts.quote": "Citi afiŝon",
  "keyboard_shortcuts.reply": "Respondu al afiŝo",
  "keyboard_shortcuts.requests": "Malfermi la liston de petoj por sekvado",
  "keyboard_shortcuts.search": "Enfokusigi la serĉbreton",
  "keyboard_shortcuts.spoilers": "Montri/kaŝi CW-kampon",
  "keyboard_shortcuts.start": "Malfermu \"por komenci\" kolumnon",
  "keyboard_shortcuts.toggle_hidden": "Montri/kaŝi tekston malantaŭ CW",
  "keyboard_shortcuts.toggle_sensitivity": "Montri/kaŝi vidaŭdaĵojn",
  "keyboard_shortcuts.toot": "Komencu novan afiŝon",
  "keyboard_shortcuts.translate": "Traduki afiŝon",
  "keyboard_shortcuts.unfocus": "Senfokusigi verki tekstareon/serĉon",
  "keyboard_shortcuts.up": "Movu supren en la listo",
  "learn_more_link.got_it": "Komprenite",
  "learn_more_link.learn_more": "Lernu pli",
  "lightbox.close": "Fermi",
  "lightbox.next": "Antaŭen",
  "lightbox.previous": "Malantaŭen",
  "lightbox.zoom_in": "Zomi al reala grandeco",
  "lightbox.zoom_out": "Zomi por konveni",
  "limited_account_hint.action": "Montru profilon ĉiukaze",
  "limited_account_hint.title": "La profilo estas kaŝita de la moderigantoj de {domain}.",
  "link_preview.author": "De {name}",
  "link_preview.more_from_author": "Pli de {name}",
  "link_preview.shares": "{count, plural, one {{counter} afiŝo} other {{counter} afiŝoj}}",
  "lists.add_member": "Aldoni",
  "lists.add_to_list": "Aldoni al la listo",
  "lists.add_to_lists": "Aldoni {name} al la listo",
  "lists.create": "Krei",
  "lists.create_a_list_to_organize": "Krei novan liston por organizi vian Hejmpaĝon",
  "lists.create_list": "Krei liston",
  "lists.delete": "Forigi la liston",
  "lists.done": "Farita",
  "lists.edit": "Redakti la liston",
  "lists.exclusive": "Kaŝi membrojn en Hejmpaĝo",
  "lists.exclusive_hint": "Se iu estas en ĉi tiuj listo, kaŝu ilin en via hejmpaĝo por eviti vidi iliajn afiŝojn dufoje.",
  "lists.find_users_to_add": "Trovi uzantojn por aldoni",
  "lists.list_members_count": "{count, plural,one {# membro} other {# membroj}}",
  "lists.list_name": "Nomo de la listo",
  "lists.new_list_name": "Nomo de nova listo",
  "lists.no_lists_yet": "Ankoraŭ ne estas listoj.",
  "lists.no_members_yet": "Ankoraŭ neniuj membroj.",
  "lists.no_results_found": "Neniuj rezultoj trovitaj.",
  "lists.remove_member": "Forigi",
  "lists.replies_policy.followed": "Iu sekvanta uzanto",
  "lists.replies_policy.list": "Membroj de la listo",
  "lists.replies_policy.none": "Neniu",
  "lists.save": "Konservi",
  "lists.search": "Ŝerci",
  "lists.show_replies_to": "Inkludi respondojn de listomembroj al",
  "load_pending": "{count,plural, one {# nova elemento} other {# novaj elementoj}}",
  "loading_indicator.label": "Ŝargado…",
  "media_gallery.hide": "Kaŝi",
  "moved_to_account_banner.text": "Via konto {disabledAccount} estas malvalidigita ĉar vi movis ĝin al {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Kaŝi el sciigoj",
  "mute_modal.hide_options": "Kaŝi agordojn",
  "mute_modal.indefinite": "Ĝis mi malsilentas ilin",
  "mute_modal.show_options": "Montri agordojn",
  "mute_modal.they_can_mention_and_follow": "Ili povas mencii kaj sekvi vin, sed vi ne vidos ilin.",
  "mute_modal.they_wont_know": "Ili ne scios, ke ili estas silentigitaj.",
  "mute_modal.title": "Ĉu silentigi uzanton?",
  "mute_modal.you_wont_see_mentions": "Vi ne vidos afiŝojn, kiuj mencias ilin.",
  "mute_modal.you_wont_see_posts": "Ili ankoraŭ povas vidi viajn afiŝojn, sed vi ne vidos iliajn.",
  "navigation_bar.about": "Pri",
  "navigation_bar.account_settings": "Pasvorto kaj sekureco",
  "navigation_bar.administration": "Administrado",
  "navigation_bar.advanced_interface": "Malfermi altnivelan retpaĝan interfacon",
  "navigation_bar.automated_deletion": "Aŭtomata forigo de afiŝoj",
  "navigation_bar.blocks": "Blokitaj uzantoj",
  "navigation_bar.bookmarks": "Legosignoj",
  "navigation_bar.direct": "Privataj mencioj",
  "navigation_bar.domain_blocks": "Blokitaj domajnoj",
  "navigation_bar.favourites": "Stelumoj",
  "navigation_bar.filters": "Silentigitaj vortoj",
  "navigation_bar.follow_requests": "Petoj de sekvado",
  "navigation_bar.followed_tags": "Sekvataj kradvortoj",
  "navigation_bar.follows_and_followers": "Sekvatoj kaj sekvantoj",
  "navigation_bar.import_export": "Importo kaj eksporto",
  "navigation_bar.lists": "Listoj",
  "navigation_bar.logout": "Elsaluti",
  "navigation_bar.moderation": "Modereco",
  "navigation_bar.more": "Pli",
  "navigation_bar.mutes": "Silentigitaj uzantoj",
  "navigation_bar.opened_in_classic_interface": "Afiŝoj, kontoj, kaj aliaj specifaj paĝoj kiuj estas malfermititaj defaulta en la klasika reta interfaco.",
  "navigation_bar.preferences": "Preferoj",
  "navigation_bar.privacy_and_reach": "Privateco kaj atingo",
  "navigation_bar.search": "Serĉi",
  "navigation_panel.expand_followed_tags": "Malfermi la menuon de sekvataj haŝetikedoj",
  "navigation_panel.expand_lists": "Malfermi la listmenuon",
  "not_signed_in_indicator.not_signed_in": "Necesas saluti por aliri tiun rimedon.",
  "notification.admin.report": "{name} raportis {target}",
  "notification.admin.report_account": "{name} raportis {count, plural, one {afiŝon} other {# afiŝojn}} de {target} por {category}",
  "notification.admin.report_account_other": "{name} raportis {count, plural, one {afiŝon} other {# afiŝojn}} de {target}",
  "notification.admin.report_statuses": "{name} raportis {target} por {category}",
  "notification.admin.report_statuses_other": "{name} raportis {target}",
  "notification.admin.sign_up": "{name} kreis konton",
  "notification.admin.sign_up.name_and_others": "{name} kaj {count, plural, one {# alia} other {# aliaj}} kreis konton",
  "notification.annual_report.message": "Via {year} #Wrapstodon atendas! Malkovru viajn bonaĵojn kaj memorindajn momentojn en Mastodon!",
  "notification.annual_report.view": "Vidu #Wrapstodon",
  "notification.favourite": "{name} ŝatis vian afiŝon",
  "notification.favourite.name_and_others_with_link": "{name} kaj <a>{count, plural, one {# alia} other {# aliaj}}</a> ŝatis vian afiŝon",
  "notification.favourite_pm": "{name} ŝatis vian privatan mencion",
  "notification.favourite_pm.name_and_others_with_link": "{name} kaj <a>{count, plural, one {# alia} other {# aliaj}}</a> ŝatis vian privatan mencion",
  "notification.follow": "{name} eksekvis vin",
  "notification.follow.name_and_others": "{name} kaj <a>{count, plural, one {# alia} other {# aliaj}}</a> sekvis vin",
  "notification.follow_request": "{name} petis sekvi vin",
  "notification.follow_request.name_and_others": "{name} kaj {count, plural, one {# alia} other {# aliaj}} petis sekvi vin",
  "notification.label.mention": "Mencii",
  "notification.label.private_mention": "Privata mencio",
  "notification.label.private_reply": "Privata respondo",
  "notification.label.quote": "{name} citis vian afiŝon",
  "notification.label.reply": "Respondi",
  "notification.mention": "Mencii",
  "notification.mentioned_you": "{name} menciis vin",
  "notification.moderation-warning.learn_more": "Lerni pli",
  "notification.moderation_warning": "Vi ricevis reguligan averton",
  "notification.moderation_warning.action_delete_statuses": "Kelkaj el viaj afiŝoj estis forigitaj.",
  "notification.moderation_warning.action_disable": "Via konto estas malŝaltita.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Kelkaj el viaj afiŝoj estis markitaj kiel sentemaj.",
  "notification.moderation_warning.action_none": "Via konto ricevis reguligan averton.",
  "notification.moderation_warning.action_sensitive": "Viaj afiŝoj estos markitaj kiel sentemaj ekde nun.",
  "notification.moderation_warning.action_silence": "Via konto estis limigita.",
  "notification.moderation_warning.action_suspend": "Via konto estas malakceptita.",
  "notification.own_poll": "Via balotenketo finiĝitis",
  "notification.poll": "Balotenketo, en kiu vi voĉdonis, finiĝis",
  "notification.quoted_update": "{name} redaktis afiŝon, kiun vi citis",
  "notification.reblog": "{name} diskonigis vian afiŝon",
  "notification.reblog.name_and_others_with_link": "{name} kaj <a>{count, plural, one {# alia} other {# aliaj}}</a> diskonigis vian afiŝon",
  "notification.relationships_severance_event": "Perditaj konektoj kun {name}",
  "notification.relationships_severance_event.account_suspension": "Administranto de {from} malakceptis {target}, kio signifas, ke vi ne plu povas ricevi ĝisdatigojn de ili aŭ interagi kun ili.",
  "notification.relationships_severance_event.domain_block": "Administranto de {from} blokis {target}, inkluzive de {followersCount} de viaj sekvantoj kaj {followingCount, plural, one {# konto} other {# kontoj}} kiujn vi sekvas.",
  "notification.relationships_severance_event.learn_more": "Lerni pli",
  "notification.relationships_severance_event.user_domain_block": "Vi blokis {target}, forigante {followersCount} de viaj sekvantoj kaj {followingCount, plural, one {# konto} other {# kontoj}} kiujn vi sekvas.",
  "notification.status": "{name} ĵus afiŝis",
  "notification.update": "{name} redaktis afiŝon",
  "notification_requests.accept": "Akcepti",
  "notification_requests.accept_multiple": "{count, plural, one {Akcepti # peton…} other {Akcepti # petojn…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Akcepti peton} other {Akcepti petojn}}",
  "notification_requests.confirm_accept_multiple.message": "Vi estas akceptonta {count, plural, one {unu sciigan peton} other {# sciigajn petojn}}. Ĉu vi certas, ke vi volas daŭrigi?",
  "notification_requests.confirm_accept_multiple.title": "Ĉu akcepti sciigajn petojn?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Malakcepti peton} other {Malakcepti petojn}}",
  "notification_requests.confirm_dismiss_multiple.message": "Vi estas malakceptonta {count, plural, one {unu sciigan peton} other {# sciigajn petojn}}. Vi ne povos facile aliri {count, plural, one {ĝin} other {ilin}} denove. Ĉu vi certas, ke vi volas daŭrigi?",
  "notification_requests.confirm_dismiss_multiple.title": "Ĉu malakcepti sciigajn petojn?",
  "notification_requests.dismiss": "Forĵeti",
  "notification_requests.dismiss_multiple": "{count, plural, one {Malakcepti # peton…} other {# Malakcepti # petojn…}}",
  "notification_requests.edit_selection": "Redakti",
  "notification_requests.exit_selection": "Farita",
  "notification_requests.explainer_for_limited_account": "Sciigoj de ĉi tiu konto estis filtritaj ĉar la konto estis limigita de reguligisto.",
  "notification_requests.explainer_for_limited_remote_account": "Sciigoj de ĉi tiu konto estis filtritaj ĉar la konto aŭ ĝia servilo estis limigitaj de reguligisto.",
  "notification_requests.maximize": "Maksimumigi",
  "notification_requests.minimize_banner": "Minimumigi filtritajn sciigojn-rubandon",
  "notification_requests.notifications_from": "Sciigoj de {name}",
  "notification_requests.title": "Filtritaj sciigoj",
  "notification_requests.view": "Vidi sciigojn",
  "notifications.clear": "Forviŝi sciigojn",
  "notifications.clear_confirmation": "Ĉu vi certas, ke vi volas porĉiame forviŝi ĉiujn viajn sciigojn?",
  "notifications.clear_title": "Ĉu forigi sciigojn?",
  "notifications.column_settings.admin.report": "Novaj raportoj:",
  "notifications.column_settings.admin.sign_up": "Novaj registriĝoj:",
  "notifications.column_settings.alert": "Sciigoj de la retumilo",
  "notifications.column_settings.favourite": "Stelumoj:",
  "notifications.column_settings.filter_bar.advanced": "Montri ĉiujn kategoriojn",
  "notifications.column_settings.filter_bar.category": "Rapida filtrila breto",
  "notifications.column_settings.follow": "Novaj sekvantoj:",
  "notifications.column_settings.follow_request": "Novaj petoj de sekvado:",
  "notifications.column_settings.group": "Grupigi",
  "notifications.column_settings.mention": "Mencioj:",
  "notifications.column_settings.poll": "Balotenketaj rezultoj:",
  "notifications.column_settings.push": "Puŝsciigoj",
  "notifications.column_settings.quote": "Citaĵoj:",
  "notifications.column_settings.reblog": "Diskonigoj:",
  "notifications.column_settings.show": "Montri en kolumno",
  "notifications.column_settings.sound": "Eligi sonon",
  "notifications.column_settings.status": "Novaj afiŝoj:",
  "notifications.column_settings.unread_notifications.category": "Nelegitaj sciigoj",
  "notifications.column_settings.unread_notifications.highlight": "Marki nelegitajn sciigojn",
  "notifications.column_settings.update": "Redaktoj:",
  "notifications.filter.all": "Ĉiuj",
  "notifications.filter.boosts": "Diskonigoj",
  "notifications.filter.favourites": "Stelumoj",
  "notifications.filter.follows": "Sekvatoj",
  "notifications.filter.mentions": "Mencioj",
  "notifications.filter.polls": "Balotenketaj rezultoj",
  "notifications.filter.statuses": "Ĝisdatigoj de homoj, kiujn vi sekvas",
  "notifications.grant_permission": "Doni permeson.",
  "notifications.group": "{count} sciigoj",
  "notifications.mark_as_read": "Marki ĉiujn sciigojn legita",
  "notifications.permission_denied": "Labortablaj sciigoj ne disponeblas pro peto antaŭe rifuzita de retumiloj",
  "notifications.permission_denied_alert": "Labortablaj sciigoj ne povas esti ebligitaj, ĉar retumilpermeso antaŭe estis rifuzita",
  "notifications.permission_required": "Labortablaj sciigoj ne disponeblas ĉar la bezonata permeso ne estis donita.",
  "notifications.policy.accept": "Akcepti",
  "notifications.policy.accept_hint": "Montri en sciigoj",
  "notifications.policy.drop": "Ignori",
  "notifications.policy.drop_hint": "Sendi al la malpleno, por neniam esti vidita denove",
  "notifications.policy.filter": "Filtri",
  "notifications.policy.filter_hint": "Sendi al filtritaj sciigoj-enirkesto",
  "notifications.policy.filter_limited_accounts_hint": "Limigita de servilaj reguligistoj",
  "notifications.policy.filter_limited_accounts_title": "Reguligitaj kontoj",
  "notifications.policy.filter_new_accounts.hint": "Kreite en la {days, plural, one {lasta tago} other {# lastaj tagoj}}",
  "notifications.policy.filter_new_accounts_title": "Novaj kontoj",
  "notifications.policy.filter_not_followers_hint": "Inkluzive de homoj, kiuj sekvis vin malpli ol {days, plural, one {unu tago} other {# tagoj}}",
  "notifications.policy.filter_not_followers_title": "Homoj, kiuj ne sekvas vin",
  "notifications.policy.filter_not_following_hint": "Ĝis vi permane aprobas ilin",
  "notifications.policy.filter_not_following_title": "Homoj, kiujn vi ne sekvas",
  "notifications.policy.filter_private_mentions_hint": "Filtrite krom se ĝi respondas al via propra mencio aŭ se vi sekvas la sendinton",
  "notifications.policy.filter_private_mentions_title": "Nepetitaj privataj mencioj",
  "notifications.policy.title": "Administri sciigojn de…",
  "notifications_permission_banner.enable": "Ŝalti retumilajn sciigojn",
  "notifications_permission_banner.how_to_control": "Por ricevi sciigojn kiam Mastodon ne estas malfermita, ebligu labortablajn sciigojn. Vi povas regi precize kiuj specoj de interagoj generas labortablajn sciigojn per la supra butono {icon} post kiam ili estas ebligitaj.",
  "notifications_permission_banner.title": "Neniam preterlasas iun ajn",
  "onboarding.follows.back": "Reen",
  "onboarding.follows.empty": "Bedaŭrinde, neniu rezulto estas montrebla nuntempe. Vi povas provi serĉi aŭ foliumi la esploran paĝon por trovi kontojn por sekvi, aŭ retrovi baldaŭ.",
  "onboarding.follows.search": "Serĉi",
  "onboarding.follows.title": "Sekvi homojn por komenci",
  "onboarding.profile.discoverable": "Trovebligi mian profilon",
  "onboarding.profile.discoverable_hint": "Kiam vi aliĝi al trovebleco ĉe Mastodon, viaj afiŝoj eble aperos en serĉaj rezultoj kaj populariĝoj, kaj via profilo eble estas sugestota al personoj kun similaj intereseoj al vi.",
  "onboarding.profile.display_name": "Publika nomo",
  "onboarding.profile.display_name_hint": "Via plena nomo aŭ via kromnomo…",
  "onboarding.profile.note": "Sinprezento",
  "onboarding.profile.note_hint": "Vi povas @mencii aliajn homojn aŭ #kradvortojn…",
  "onboarding.profile.title": "Profila fikso",
  "onboarding.profile.upload_avatar": "Alŝuti profilbildon",
  "onboarding.profile.upload_header": "Alŝuti profilkapbildon",
  "password_confirmation.exceeds_maxlength": "Pasvorto-konfirmo superas la maksimuman pasvortan longon",
  "password_confirmation.mismatching": "Pasvorto konfirmo ne kongruas",
  "picture_in_picture.restore": "Remetu ĝin",
  "poll.closed": "Finita",
  "poll.refresh": "Aktualigi",
  "poll.reveal": "Vidi rezultojn",
  "poll.total_people": "{count, plural, one {# homo} other {# homoj}}",
  "poll.total_votes": "{count, plural, one {# voĉdono} other {# voĉdonoj}}",
  "poll.vote": "Voĉdoni",
  "poll.voted": "Vi voĉdonis por ĉi tiu respondo",
  "poll.votes": "{votes, plural, one {# voĉdono} other {# voĉdonoj}}",
  "poll_button.add_poll": "Aldoni balotenketon",
  "poll_button.remove_poll": "Forigi balotenketon",
  "privacy.change": "Ŝanĝu afiŝan privatecon",
  "privacy.direct.long": "Ĉiuj menciitaj en la afiŝo",
  "privacy.direct.short": "Privata mencio",
  "privacy.private.long": "Nur viaj sekvantoj",
  "privacy.private.short": "Sekvantoj",
  "privacy.public.long": "Ĉiujn ajn ĉe kaj ekster Mastodon",
  "privacy.public.short": "Publika",
  "privacy.quote.disabled": "{visibility}, malŝaltitaj citaĵoj",
  "privacy.quote.limited": "{visibility}, limigitaj citaĵoj",
  "privacy.unlisted.additional": "Ĉi tio kondutas ekzakte kiel publika, krom ke la afiŝo ne aperos en vivaj fluoj aŭ kradvortoj, esploro aŭ Mastodon-serĉo, eĉ se vi estas enskribita en la tuta konto.",
  "privacy.unlisted.short": "Diskrete publika",
  "privacy_policy.last_updated": "Laste ĝisdatigita en {date}",
  "privacy_policy.title": "Politiko de privateco",
  "quote_error.poll": "Citado ne estas permesita ĉe balotenketoj.",
  "quote_error.quote": "Nur unu citaĵo samtempe estas permesita.",
  "quote_error.unauthorized": "Vi ne rajtas citi tiun ĉi afiŝon.",
  "recommended": "Rekomendita",
  "refresh": "Refreŝigu",
  "regeneration_indicator.please_stand_by": "Bonvolu atendi.",
  "regeneration_indicator.preparing_your_home_feed": "Preparante vian hejmpaĝon…",
  "relative_time.days": "{number}t",
  "relative_time.full.days": "antaŭ {number, plural, one {# tago} other {# tagoj}}",
  "relative_time.full.hours": "antaŭ {number, plural, one {# horo} other {# horoj}}",
  "relative_time.full.just_now": "ĵus nun",
  "relative_time.full.minutes": "antaŭ {number, plural, one {# minuto} other {# minutoj}}",
  "relative_time.full.seconds": "antaŭ {number, plural, one {# sekundo} other {# sekundoj}}",
  "relative_time.hours": "{number}h",
  "relative_time.just_now": "nun",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "hodiaŭ",
  "remove_quote_hint.button_label": "Komprenite",
  "remove_quote_hint.message": "Vi povas fari tion el la menuo de opcioj {icon}.",
  "remove_quote_hint.title": "Ĉu vi volas forigi vian cititan afiŝon?",
  "reply_indicator.attachments": "{count, plural, one {# aldonaĵo} other {# aldonaĵoj}}",
  "reply_indicator.cancel": "Nuligi",
  "reply_indicator.poll": "Balotenketo",
  "report.block": "Bloki",
  "report.block_explanation": "Vi ne vidos iliajn afiŝojn. Ili ne povos vidi viajn afiŝojn, nek sekvi vin. Ili ne scios, ke vi blokas ilin.",
  "report.categories.legal": "Laŭleĝa",
  "report.categories.other": "Aliaj",
  "report.categories.spam": "Trudmesaĝo",
  "report.categories.violation": "Enhavo malobservas unu aŭ plurajn servilajn regulojn",
  "report.category.subtitle": "Elektu la plej bonan kongruon",
  "report.category.title": "Diru al ni kio okazas pri ĉi tiu {type}",
  "report.category.title_account": "profilo",
  "report.category.title_status": "afiŝo",
  "report.close": "Farita",
  "report.comment.title": "Ĉu estas ajn ion alian kiun vi pensas ke ni devus scii?",
  "report.forward": "Plusendi al {target}",
  "report.forward_hint": "La konto estas de alia servilo. Ĉu vi volas sendi anoniman kopion de la raporto ankaŭ al tie?",
  "report.mute": "Silentigi",
  "report.mute_explanation": "Vi ne vidos iliajn afiŝojn. Ili ankoraŭ povas sekvi vin kaj vidi viajn afiŝojn, kaj ne scios ke ili estas silentigitaj.",
  "report.next": "Antaŭen",
  "report.placeholder": "Pliaj komentoj",
  "report.reasons.dislike": "Mi ne ŝatas ĝin",
  "report.reasons.dislike_description": "Ĝi ne estas io, kiun vi volas vidi",
  "report.reasons.legal": "Estas kontraŭleĝa",
  "report.reasons.legal_description": "Vi opinas, ke ĝi malobservas la leĝon en via lando, aŭ en la servila lando",
  "report.reasons.other": "Io alia",
  "report.reasons.other_description": "La problemo ne taŭgas en aliaj kategorioj",
  "report.reasons.spam": "Ĝi estas trudaĵo",
  "report.reasons.spam_description": "Trompaj ligiloj, falsa/artefarita aktiveco, aŭ ripetaj respondoj",
  "report.reasons.violation": "Ĝi malobservas la regularon de la servilo",
  "report.reasons.violation_description": "Vi scias ke ĝi malobeas specifan regulon",
  "report.rules.subtitle": "Elektu ĉiujn, kiuj validas",
  "report.rules.title": "Kiuj reguloj estas malobservataj?",
  "report.statuses.subtitle": "Elektu ĉiujn, kiuj validas",
  "report.statuses.title": "Ĉu estas afiŝoj, kiuj subtenas tiun raporton?",
  "report.submit": "Sendi",
  "report.target": "Raporti pri {target}",
  "report.thanks.take_action": "Jen viaj ebloj por regi kion vi vidas ĉe Mastodon:",
  "report.thanks.take_action_actionable": "Dum ni kontrolas la raporton, vi povas agi kontraŭ @{name}:",
  "report.thanks.title": "Ĉu vi ne volas vidi ĉi tion?",
  "report.thanks.title_actionable": "Dankon pro raporti, ni esploros ĉi tion.",
  "report.unfollow": "Malsekvi @{name}",
  "report.unfollow_explanation": "Vi sekvas ĉi tiun konton. Por ne plu vidi ĝiajn afiŝojn en via hejma templinio, ĉesu sekvi ĝin.",
  "report_notification.attached_statuses": "{count, plural, one {{count} afiŝo almetita} other {{count} afiŝoj almetitaj}}",
  "report_notification.categories.legal": "Laŭleĝa",
  "report_notification.categories.legal_sentence": "kontraŭleĝa enhavo",
  "report_notification.categories.other": "Alia",
  "report_notification.categories.other_sentence": "alia",
  "report_notification.categories.spam": "Trudmesaĝo",
  "report_notification.categories.spam_sentence": "trudmesaĝo",
  "report_notification.categories.violation": "Malobservo de la regulo",
  "report_notification.categories.violation_sentence": "malobservo de la regulo",
  "report_notification.open": "Malfermi la raporton",
  "search.clear": "검색어 지우기",
  "search.no_recent_searches": "Neniuj lastaj serĉoj",
  "search.placeholder": "Serĉi",
  "search.quick_action.account_search": "Profiloj kiuj kongruas kun {x}",
  "search.quick_action.go_to_account": "Iri al profilo {x}",
  "search.quick_action.go_to_hashtag": "Iri al kradvorto {x}",
  "search.quick_action.open_url": "Malfermi URL en Mastodono",
  "search.quick_action.status_search": "Afiŝoj kiuj konformas kun {x}",
  "search.search_or_paste": "Serĉu aŭ algluu URL-on",
  "search_popout.full_text_search_disabled_message": "Ne disponebla sur {domain}.",
  "search_popout.full_text_search_logged_out_message": "Disponebla nur kiam ensalutinte.",
  "search_popout.language_code": "ISO-lingva kodo",
  "search_popout.options": "Serĉaj opcioj",
  "search_popout.quick_actions": "Rapidaj agoj",
  "search_popout.recent": "Lastaj serĉoj",
  "search_popout.specific_date": "specifa dato",
  "search_popout.user": "uzanto",
  "search_results.accounts": "Profiloj",
  "search_results.all": "Ĉiuj",
  "search_results.hashtags": "Kradvortoj",
  "search_results.no_results": "Ne estas rezultoj.",
  "search_results.no_search_yet": "Provu serĉi afiŝojn, profilojn aŭ kradvortojn.",
  "search_results.see_all": "Vidi ĉiujn",
  "search_results.statuses": "Afiŝoj",
  "search_results.title": "Serĉu \"{q}\"",
  "server_banner.about_active_users": "Personoj uzantaj ĉi tiun servilon dum la lastaj 30 tagoj (Aktivaj Uzantoj Monate)",
  "server_banner.active_users": "aktivaj uzantoj",
  "server_banner.administered_by": "Administrata de:",
  "server_banner.is_one_of_many": "{domain} estas unu el la multaj sendependaj Mastodon-serviloj, kiujn vi povas uzi por partopreni en la fediverso.",
  "server_banner.server_stats": "Statistikoj de la servilo:",
  "sign_in_banner.create_account": "Krei konton",
  "sign_in_banner.follow_anyone": "Sekvu iun ajn tra la fediverso kaj vidu ĉion laŭ templinio. Nul algoritmo, reklamo aŭ kliklogilo ĉeestas.",
  "sign_in_banner.mastodon_is": "Mastodon estas la plej bona maniero resti ĝisdata pri aktualaĵoj.",
  "sign_in_banner.sign_in": "Ensaluti",
  "sign_in_banner.sso_redirect": "Ensalutu aŭ Registriĝi",
  "status.admin_account": "Malfermi fasadon de la reguligado por @{name}",
  "status.admin_domain": "Malfermi fasadon de la reguligado por {domain}",
  "status.admin_status": "Malfermi ĉi tiun afiŝon en la fasado de la reguligado",
  "status.all_disabled": "Diskonigoj kaj citaĵoj estas \tmalvalidigitaj",
  "status.block": "Bloki @{name}",
  "status.bookmark": "Aldoni al la legosignoj",
  "status.cancel_reblog_private": "Ne plu diskonigi",
  "status.cannot_quote": "Vi ne rajtas citi ĉi tiun afiŝon",
  "status.cannot_reblog": "Ĉi tiun afiŝon ne eblas diskonigi",
  "status.context.show": "Montri",
  "status.continued_thread": "Daŭrigis fadenon",
  "status.copy": "Kopii la ligilon al la afiŝo",
  "status.delete": "Forigi",
  "status.delete.success": "Afiŝo forigita",
  "status.detailed_status": "Detala konversacia vido",
  "status.direct": "Private mencii @{name}",
  "status.direct_indicator": "Privata mencio",
  "status.edit": "Redakti",
  "status.edited": "Laste redaktita {date}",
  "status.edited_x_times": "Redactita {count, plural, one {{count} fojon} other {{count} fojojn}}",
  "status.embed": "Akiri enkorpigan kodon",
  "status.favourite": "Ŝatata",
  "status.filter": "Filtri ĉi tiun afiŝon",
  "status.history.created": "{name} kreis {date}",
  "status.history.edited": "{name} redaktis {date}",
  "status.load_more": "Ŝargi pli",
  "status.media.open": "Alklaki por malfermi",
  "status.media.show": "Alklaki por montri",
  "status.media_hidden": "Vidaŭdaĵo kaŝita",
  "status.mention": "Mencii @{name}",
  "status.more": "Pli",
  "status.mute": "Silentigi @{name}",
  "status.mute_conversation": "Silentigi konversacion",
  "status.open": "Pligrandigu ĉi tiun afiŝon",
  "status.pin": "Alpingli al la profilo",
  "status.quote": "Citaĵo",
  "status.quote.cancel": "Nuligi citaĵon",
  "status.quote_error.filtered": "Kaŝita pro unu el viaj filtriloj",
  "status.quote_error.not_available": "Afiŝo ne disponebla",
  "status.quote_error.pending_approval": "Pritraktata afiŝo",
  "status.quote_error.pending_approval_popout.body": "Ĉe Mastodon, vi povas kontroli ĉu iu rajtas citi vin. Ĉi tiu afiŝo estas atendata dum ni akiras la aprobon de la originala aŭtoro.",
  "status.quote_error.revoked": "Afiŝo forigita de aŭtoro",
  "status.quote_followers_only": "Nur sekvantoj rajtas citi tiun ĉi afiŝon",
  "status.quote_manual_review": "Aŭtoro permane revizios",
  "status.quote_policy_change": "Ŝanĝi kiu povas citi",
  "status.quote_post_author": "Citis afiŝon de @{name}",
  "status.quote_private": "Privataj afiŝoj ne povas esti cititaj",
  "status.quotes.empty": "Neniu citis ĉi tiun afiŝon ankoraŭ. Kiam iu faros tion, ĝi aperos ĉi tie.",
  "status.read_more": "Legi pli",
  "status.reblog": "Diskonigi",
  "status.reblog_or_quote": "Diskonigi aŭ citi",
  "status.reblog_private": "Kunhavigu denove kun viaj sekvantoj",
  "status.reblogged_by": "{name} diskonigis",
  "status.reblogs.empty": "Ankoraŭ neniu diskonigis tiun afiŝon. Kiam iu faras tion, ri aperos ĉi tie.",
  "status.redraft": "Forigi kaj reskribi",
  "status.remove_bookmark": "Forigi legosignon",
  "status.remove_favourite": "Forigi el plej ŝatataj",
  "status.remove_quote": "Forigi",
  "status.replied_in_thread": "Respondis en fadeno",
  "status.replied_to": "Respondis al {name}",
  "status.reply": "Respondi",
  "status.replyAll": "Respondi al la fadeno",
  "status.report": "Raporti @{name}",
  "status.request_quote": "Peto por citi",
  "status.revoke_quote": "Forigu mian afiŝon el la afiŝo de @{name}",
  "status.sensitive_warning": "Tikla enhavo",
  "status.share": "Kundividi",
  "status.show_less_all": "Montri malpli ĉiun",
  "status.show_more_all": "Montri pli ĉiun",
  "status.show_original": "Montru originalon",
  "status.title.with_attachments": "{user} afiŝis {attachmentCount, plural, one {aldonaĵon} other {{attachmentCount} aldonaĵojn}}",
  "status.translate": "Traduki",
  "status.translated_from_with": "Tradukita el {lang} per {provider}",
  "status.uncached_media_warning": "Antaŭrigardo ne disponebla",
  "status.unmute_conversation": "Malsilentigi la konversacion",
  "status.unpin": "Depingli de profilo",
  "subscribed_languages.lead": "Nur afiŝoj en elektitaj lingvoj aperos en viaj hejma kaj lista templinioj post la ŝanĝo. Elektu nenion por ricevi afiŝojn en ĉiuj lingvoj.",
  "subscribed_languages.save": "Konservi ŝanĝojn",
  "subscribed_languages.target": "Ŝanĝu abonitajn lingvojn por {target}",
  "tabs_bar.home": "Hejmo",
  "tabs_bar.menu": "Menuo",
  "tabs_bar.notifications": "Sciigoj",
  "tabs_bar.publish": "Nova afiŝo",
  "tabs_bar.search": "Serĉi",
  "terms_of_service.effective_as_of": "Ĝi ekvalidas de {date}",
  "terms_of_service.title": "Kondiĉoj de uzado",
  "terms_of_service.upcoming_changes_on": "Venontaj ŝanĝoj el {date}",
  "time_remaining.days": "{number, plural, one {# tago} other {# tagoj}} restas",
  "time_remaining.hours": "{number, plural, one {# horo} other {# horoj}} restas",
  "time_remaining.minutes": "{number, plural, one {# minuto} other {# minutoj}} restas",
  "time_remaining.moments": "Momenteto restas",
  "time_remaining.seconds": "{number, plural, one {# sekundo} other {# sekundoj}} restas",
  "trends.counter_by_accounts": "{count, plural, one {{counter} persono} other {{counter} personoj}} dum la pasinta{days, plural, one { tago} other {j {days} tagoj}}",
  "trends.trending_now": "Nunaj furoraĵoj",
  "ui.beforeunload": "Via malneto perdiĝos se vi eliras de Mastodon.",
  "units.short.billion": "{count}Md",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Altreni kaj lasi por alŝuti",
  "upload_button.label": "Aldonu bildojn, filmeton aŭ sondosieron",
  "upload_error.limit": "Limo de dosiera alŝutado transpasita.",
  "upload_error.poll": "Alŝuto de dosiero ne permesita kun balotenketo.",
  "upload_error.quote": "Ne estas permesita alŝuto de dosieroj kun citaĵoj.",
  "upload_form.drag_and_drop.instructions": "Por preni amaskomunikilaron aldonaĵon, premu spacoklavon aŭ enen-klavon. Dum trenado, uzu la sagoklavojn por movi la amaskomunikilaron aldonaĵon en iu ajn direkto. Premu spacoklavon aŭ enen-klavon denove por faligi la amaskomunikilaron aldonaĵon en ĝia nova pozicio, aŭ premu eskapan klavon por nuligi.",
  "upload_form.drag_and_drop.on_drag_cancel": "Trenado estis nuligita. Amaskomunikila aldonaĵo {item} estis forigita.",
  "upload_form.drag_and_drop.on_drag_end": "Amaskomunikila aldonaĵo {item} estis forigita.",
  "upload_form.drag_and_drop.on_drag_over": "Amaskomunikila aldonaĵo {item} estis movita.",
  "upload_form.drag_and_drop.on_drag_start": "Prenis amaskomunikilan aldonaĵon {item}.",
  "upload_form.edit": "Redakti",
  "upload_progress.label": "Alŝutante...",
  "upload_progress.processing": "Traktante…",
  "username.taken": "La uzantnomo estas jam posedita. Provu alion",
  "video.close": "Fermu la filmeton",
  "video.download": "Elŝuti dosieron",
  "video.exit_fullscreen": "Eksigi plenekrana",
  "video.expand": "Pligrandigi la videon",
  "video.fullscreen": "Igi plenekrana",
  "video.hide": "Kaŝu la filmeton",
  "video.mute": "Silentigi",
  "video.pause": "Paŭzigi",
  "video.play": "Ekigi",
  "video.skip_backward": "Preterpasi malantaŭen",
  "video.skip_forward": "Preterpasi antaŭen",
  "video.unmute": "Ne plu silentigi",
  "video.volume_down": "Laŭteco Malpliigi",
  "video.volume_up": "Laŭteco pliigi",
  "visibility_modal.button_title": "Agordu videblon",
  "visibility_modal.header": "Videblo kaj interago",
  "visibility_modal.helper.direct_quoting": "Privataj mencioj verkitaj ĉe Mastodon ne povas esti cititaj de aliaj.",
  "visibility_modal.helper.privacy_editing": "Videbleco ne povas esti ŝanĝita post publikigo de afiŝo.",
  "visibility_modal.helper.privacy_private_self_quote": "Memcitaĵoj de privataj afiŝoj ne povas esti publikigitaj.",
  "visibility_modal.helper.private_quoting": "Afiŝoj nur por sekvantoj verkitaj ĉe Mastodon ne povas esti cititaj de aliaj.",
  "visibility_modal.helper.unlisted_quoting": "Kiam homoj citas vin, ilia afiŝo ankaŭ estos kaŝita de tendencaj templinioj.",
  "visibility_modal.privacy_label": "Videbleco",
  "visibility_modal.quote_followers": "Nur sekvantoj",
  "visibility_modal.quote_label": "Kiu povas citi",
  "visibility_modal.quote_nobody": "Nur mi",
  "visibility_modal.quote_public": "Iu ajn",
  "visibility_modal.save": "Konservi"
}
